import { useTranslation } from '@rhino-project/core/i18n';
import { useEffect, useState } from 'react';
import { useDebouncer } from '@tanstack/react-pacer';
import { useModelIndexContext } from '@rhino-project/core/hooks';
import { Input, InputProps } from '@heroui/react';

export const ModelSearch = (props: Partial<InputProps>) => {
  const { t } = useTranslation();
  const { model, search, setSearch } = useModelIndexContext();
  const [searchTerm, setSearchTerm] = useState(search);
  const debounced = useDebouncer(
    (newSearch) => {
      setSearch(newSearch);
    },
    { wait: 200, key: `ModelSearch:${model.model}` }
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchTerm(value);

    // If its a value, we debounce it, otherwise set immediately because
    // its probably a clearing of the search input
    if (value) {
      debounced.maybeExecute(value);
    } else {
      debounced.cancel();
      setSearch(value);
    }
  };

  // A controller reset or model switch supersedes any pending input.
  useEffect(() => {
    debounced.cancel();
    // eslint-disable-next-line @eslint-react/set-state-in-effect, react-hooks/set-state-in-effect
    setSearchTerm(search);
  }, [search, model.model, debounced]);

  return (
    <Input
      type="search"
      placeholder={t('rhino.frontend.messages.search_label')}
      value={searchTerm}
      onChange={handleChange}
      {...props}
    />
  );
};
